import Vue from 'vue'

///////////////////////////////////////////////////////////////////////////////////////////////
// Parse, validate, manipulate, and display dates and times in JavaScript.
import moment from 'moment';
import 'moment/locale/pt';
moment.locale('pt');
window.moment = moment;
Vue.prototype.moment = window.moment;
//  JSON stringify a javascript Date and preserve timezone
Date.prototype.toJSON = function(){ return moment(this).format(); }

///////////////////////////////////////////////////////////////////////////////////////////////
// jQuery is a fast, small, and feature-rich JavaScript library. It makes things like HTML
// document traversal and manipulation, event handling, animation, and Ajax much simpler with
// an easy-to-use API that works across a multitude of browsers.
import jquery from 'jquery';
window.$ = window.jQuery = jquery

// jQuery UI - Draggable + Resizable
import jQueryDraggableResizable from '@/libraries/jquery/ui/jquery-ui.draggable.resizable.min.js';

///////////////////////////////////////////////////////////////////////////////////////////////
// Build responsive, mobile-first projects on the web with the world’s most popular front-end
// component library.
import 'bootstrap';

///////////////////////////////////////////////////////////////////////////////////////////////
// toastr is a Javascript library for non-blocking notifications. jQuery is required. The goal
// is to create a simple core library that can be customized and extended.
import Toastr from 'vue-toastr'
require('vue-toastr/src/vue-toastr.scss')
Vue.use(Toastr)

///////////////////////////////////////////////////////////////////////////////////////////////
// VeeValidate is a validation library for Vue.js. It has plenty of validation rules out of
// the box and support for custom ones as well. It is template based so it is similar and familiar
// with the HTML5 validation API. You can validate HTML5 inputs as well as custom Vue components.
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

///////////////////////////////////////////////////////////////////////////////////////////////
// A Vue.js select component that provides similar functionality to Select2 without the
// overhead of jQuery.
// import vSelect from 'vue-select/src/index.js'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('v-select', vSelect)

///////////////////////////////////////////////////////////////////////////////////////////////
// Utilizes Bootstraps modal plugin to implement a lightbox gallery
// require('ekko-lightbox/dist/ekko-lightbox.css')
// require('ekko-lightbox/dist/ekko-lightbox.js')

///////////////////////////////////////////////////////////////////////////////////////////////
// Bootstrap Multiselect is a jQuery based plugin that allows users to tick multiple options
// from a standard Bootstrap select.
// require('knockout');
// require('bootstrap-multiselect/dist/js/bootstrap-multiselect.js')
// require('bootstrap-multiselect/dist/js/bootstrap-multiselect-collapsible-groups.js')
// require('bootstrap-multiselect/dist/css/bootstrap-multiselect.css')


///////////////////////////////////////////////////////////////////////////////////////////////
// A lightweight (2KB gzipped) and dependency free mask input created specific for Vue.js
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

///////////////////////////////////////////////////////////////////////////////////////////////
// Originally created for reports at Improvely, the Date Range Picker can be attached to any
// webpage element to pop up two calendars for selecting dates, times, or predefined ranges
// like "Last 30 Days".
require('daterangepicker/daterangepicker.css')
require('daterangepicker/daterangepicker.js')

///////////////////////////////////////////////////////////////////////////////////////////////
// This is a Vue number plugin. It animates the number that you pass in prop.
import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)

///////////////////////////////////////////////////////////////////////////////////////////////
// Vue.js toggle/switch button.
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

///////////////////////////////////////////////////////////////////////////////////////////////
// jsTree is jquery plugin, that provides interactive trees. It is absolutely free, open
// source and distributed under the MIT license. jsTree is easily extendable, themable and
// configurable, it supports HTML & JSON data sources and AJAX loading.
require('../libraries/treeview/themes/default/style.min.css')
require('../libraries/treeview/jstree.min.js')
require('../libraries/form/forms.js')

///////////////////////////////////////////////////////////////////////////////////////////////
// The most complete selecting solution for Vue.js
import Multiselect from 'vue-multiselect'
require('vue-multiselect/dist/vue-multiselect.min.css')
Vue.component('multiselect', Multiselect)

// Material Design Bootstrap
// require('mdbootstrap/css/mdb.min.css')
// require('mdbootstrap/js/mdb.min.js')

///////////////////////////////////////////////////////////////////////////////////////////////
// sanitize-html provides a simple HTML sanitizer with a clear API.
import sanitizeHTML from 'sanitize-html';
Vue.prototype.$sanitize = sanitizeHTML;

///////////////////////////////////////////////////////////////////////////////////////////////
// Vue.js plugin that allows you to disable reactivity on an object
// import nonreactive from '@/app/shared/plugins/vue-nonreactive';
// Vue.use(nonreactive);

///////////////////////////////////////////////////////////////////////////////////////////////
// Vue.js Read-More
import ReadMore from 'vue-read-more';
Vue.use(ReadMore);